import React from "react"
import "./header.scss"
import { homeNavigation, navigation } from "./navigation"
import { NavLink } from "./NavLink"

export const Header = () => (
  <>
    <header className="header">
      <div className="flex-[3]">
        <NavLink nav={homeNavigation} className="logo" />
      </div>

      <input className="side-menu" type="checkbox" id="side-menu" />
      <label className="mobile-menu-toggle" htmlFor="side-menu">
        <span className="mobile-menu-line" />
      </label>

      <nav className="nav">
        <ul className="menu">
          {navigation.map((nav) => (
            <li key={nav.name}>
              <NavLink nav={nav} />
            </li>
          ))}
        </ul>
      </nav>
    </header>
  </>
)
